import { render } from "./SingleTagField.vue?vue&type=template&id=79ab08d3"
import script from "./SingleTagField.vue?vue&type=script&lang=js"
export * from "./SingleTagField.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__